// 🧿 طلسم محافظ فایل

import React from "react";
// Common Components
import { WrappedTimeSeriesChart } from "src/Components";
// Requests
import { getProfitGraph } from "src/Requests/automaticMarketMaking";
// Types
import { IVChartData } from "src/Interfaces/automaticMarketMaking";

interface IProps {
  tableId: string;
}

const ProfitGraph: React.FC<IProps> = ({ tableId }) => {
  const [dataSet, setDataSet] = React.useState<IVChartData[]>([]);

  React.useEffect(() => {
    let isCurrent = true; // Tracks if the request is for the current tableId
    let intervalId: NodeJS.Timeout;

    // Function to fetch data
    const fetchData = async () => {
      try {
        const data = await getProfitGraph(tableId);
        if (isCurrent) {
          // Only update state if the tableId hasn't changed
          setDataSet(data);
        }
      } catch (error) {
        if (isCurrent) {
          console.error("Error fetching IVGraph data:", error);
        }
      }
    };

    // Initial fetch
    fetchData();

    // Set up interval to fetch every 30 seconds
    intervalId = setInterval(fetchData, 30_000);

    // Cleanup: clear interval and mark requests as outdated when tableId changes or component unmounts
    return () => {
      isCurrent = false;
      clearInterval(intervalId);
    };
  }, [tableId]);

  return (
    <div className="w-1/2 h-1/2 " onClick={(e) => e.stopPropagation()}>
      <div className="flex flex-row h-full w-full">
        <div className=" w-full h-full">
          <WrappedTimeSeriesChart dataset={dataSet} />
        </div>
        <span
          className="text-center"
          style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)", // برای اینکه حروف برعکس نشن
          }}
        >
          ٪ بازده کانورژن
        </span>
      </div>
    </div>
  );
};

export default ProfitGraph;
